<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Requestor Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Requestor Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="requestorName" id="requestorName" placeholder="Enter Requestor Name" name="requestorName"> -->
                                <span class="form-control">{{requestorName}}</span>
                                <!-- <div class="help is-danger">{{requestorNameError}}</div> -->
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Department -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValueDepartment"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="!isHideLocationDropDown">
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        @input="location_error = ''"
                                        :options="location_arr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{location_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>
                        <!-- Vendor -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Vendor :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="vendorId" name="vendorId"
                                    label="text"
                                    @input="changedValueVendor"
                                    :options="vendorIdArr" :clearable=false placeholder="Select Vendor">
                                </v-select>
                                <div class="help is-danger">{{vendorIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="isHideLocationDropDown">
                            <div class="col-6 forms-block">
                            </div>
                        </template>
                        <template v-for="(supplier, index) in officeSupplierArr">
                            <div :key="'description ' + index" class="col-5 forms-block">
                                <div class="">
                                    <div class="form-label">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <input type="text" @input="supplier.descriptionError = ''" maxlength="190" class="form-control" v-model="supplier.description" id="description" name="description"> -->
                                    <v-select v-model="supplier.description" name="description"
                                        label="text"
                                        @input="changedValueDescription(supplier.description, index)"
                                        :options="descriptionArr" :clearable=false placeholder="Select Description">
                                    </v-select>
                                    <div class="help is-danger">{{supplier.descriptionError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>                           
                            <div :key="'Unit of Measure Code ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Unit of Measure Code :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <template v-if="vendorId.text != 'Office Max' && vendorId.text != 'Staples'">
                                        <span class="form-control">{{supplier.unitMeasureCode}}</span>    
                                        <div class="requiredstar">*</div>
                                    </template>
                                    <template v-else>
                                        <v-select v-model="supplier.unitMeasureCode" name="unitMeasureCode"
                                            label="text" @input="changedValueUnitMeasureCode(supplier.unitMeasureCode, index)"
                                            :options="unitMeasureArr" :clearable=false placeholder="Select Unit Measure Code">
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <div class="help is-danger">{{supplier.unitMeasureCodeError}}</div>
                                    </template>
                                    <!-- <input type="text" @input="supplier.unitMeasureCodeError = ''" maxlength="190" class="form-control" v-model="supplier.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode"> -->
                                </div>
                            </div>
                            <div :key="'Item No ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Item No :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control">{{supplier.itemNo}}</span>
                                    <!-- <input type="text" @input="supplier.itemNoError = ''" maxlength="190" class="form-control" v-model="supplier.itemNo" id="itemNo" name="itemNo">
                                    <div class="help is-danger">{{supplier.itemNoError}}</div> -->
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Quantity ' + index" class="col-1 forms-block">
                                <div class="">
                                    <div class="form-label">Quantity :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="supplier.quantityError = ''" maxlength="190" class="form-control" v-model="supplier.quantity" id="quantity" name="quantity">
                                    <div class="help is-danger">{{supplier.quantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <template v-if="officeSupplierArr.length == (index + 1) && plusCountSupplier != 0">
                                <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="addNewDocumentSupplier(supplier, index)" class="btn btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="removeSupplierDocument(supplier, index)" class="btn btn-danger">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </template>
                        <!-- Other -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="other">Other :</div>
                            </div>
                            <div class="col-9 paddingleft0" style="padding-top: 8px;">
                                <input id="other" v-model="other" class="form-control" type="checkbox"/>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            &nbsp;
                        </div>
                        <template v-if="showOtherOption">
                            <template v-for="(otherSup, otherIndex) in otherOfficeSupplierArr">
                                <div :key="'Other description ' + otherIndex" class="col-5 forms-block">
                                    <div class="">
                                        <div class="form-label">Description :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.descriptionError = ''" maxlength="190" class="form-control" v-model="otherSup.description" id="description" name="description">
                                        <div class="help is-danger">{{otherSup.descriptionError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Other Unit of Measure Code ' + otherIndex" class="col-2 forms-block">
                                    <div class="">
                                        <div class="form-label">Unit of Measure Code :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.unitMeasureCodeError = ''" maxlength="190" class="form-control" v-model="otherSup.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode">
                                        <div class="help is-danger">{{otherSup.unitMeasureCodeError}}</div>
                                        <!-- <div class="requiredstar">*</div> --> 
                                    </div>
                                </div>
                                <div :key="'Other Item No ' + otherIndex" class="col-3 forms-block">
                                    <div class="">
                                        <div class="form-label">Item No :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.itemNoError = ''" maxlength="190" class="form-control" v-model="otherSup.itemNo" id="itemNo" name="itemNo">
                                        <div class="help is-danger">{{otherSup.itemNoError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Other Quantity ' + otherIndex" class="col-1 forms-block">
                                    <div class="">
                                        <div class="form-label">Quantity :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.quantityError = ''" maxlength="190" class="form-control" v-model="otherSup.quantity" id="quantity" name="quantity">
                                        <div class="help is-danger">{{otherSup.quantityError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <template v-if="otherOfficeSupplierArr.length == (otherIndex + 1) && plusCountOtherSupplier != 0">
                                    <div :key="'Other plus ' + otherIndex" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="addNewDocumentOtherSupp(otherSup, otherIndex)" class="btn btn-success">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'Other close ' + otherIndex" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="removeOtherSuppDocument(otherSup, otherIndex)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addOfficeSupplier('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    // import officeSupplier from '@/json/office_supplier.json';
    var self;
    var officeSupplier = [];
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateOfficeSupplier',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Office Supplies',
                edit_id: 0,
                requestorName: "",
                requestorNameError: "",
                unitMeasureArr:[
                    {
                        text: 'Each',
                        value: 'Each',
                    },
                    {
                        text: 'Box',
                        value: 'Box',
                    },
                    {
                        text: 'Dozen',
                        value: 'Dozen',
                    },
                    {
                        text: 'Pack',
                        value: 'Pack',
                    },
                    {
                        text: 'Set',
                        value: 'Set',
                    },
                    {
                        text: 'Carton',
                        value: 'Carton',
                    }
                ],
                departmentArr: [ 
                    {
                        text: 'Call Center',
                        value: 'Call Center',
                    },
                    {
                        text: 'Central Ops',
                        value: 'Central Ops',
                    },
                    {
                        text: 'Parts',
                        value: 'Parts',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                location: "",
                location_arr: [],
                location_error: "",
                vendorId: "",
                vendorIdArr: [],
                vendorIdError: "",
                descriptionArr: [],
                officeSupplierArr: [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ],
                tempOfficeSupplierObject: {
                    description: "",
                    descriptionError: "",
                    unitMeasureCode: "",
                    unitMeasureCodeError: "",
                    itemNo: "",
                    itemNoError: "",
                    quantity: "",
                    quantityError: "",
                },
                plusCountSupplier: 9,
                otherOfficeSupplierArr: [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ],
                otherTempOfficeSupplierObject: {
                    description: "",
                    descriptionError: "",
                    unitMeasureCode: "",
                    unitMeasureCodeError: "",
                    itemNo: "",
                    itemNoError: "",
                    quantity: "",
                    quantityError: "",
                },
                plusCountOtherSupplier: 4,

                managerEmail: "",
                loginUserRoleId: 1,
                indexDes: 0,
                other: 0,
                showOtherOption: false,
                isHideLocationDropDown: false,
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
            other: function(other) {
                self.showOtherOption = false;
                self.otherOfficeSupplierArr = [];
                self.otherOfficeSupplierArr = [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ];
                if(other) {
                    self.showOtherOption = true;
                }
            },
            departmentId: function(departmentId) {
                self.isHideLocationDropDown = false;
                if (departmentId != null || departmentId.value) {
                    if(departmentId.value != 'Parts') {
                        self.isHideLocationDropDown = true;
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.loadVendor();
            self.menuActive("OfficeSuppliesForm");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.requestorName = self.formatString(userJson['first_name'] + " " + userJson['last_name']);
            }
            self.loadLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/office/supplier/list');
            },
            changedValueDepartment: function(department) {
                self.departmentIdError = "";
            },
            changedValueUnitMeasureCode: function(unitMeasureCode, unitMeasureCodeIndex) {
                self.officeSupplierArr[unitMeasureCodeIndex].unitMeasureCodeError = '';
            },
            changedValueDescription: function(description, desIndex) {
                self.officeSupplierArr[desIndex].descriptionError = '';
                if(self.vendorId.text == "Office Solution")
                {
                    self.officeSupplierArr[desIndex].unitMeasureCode = description.unit_of_measure_code;
                }
                self.officeSupplierArr[desIndex].itemNo = description.item_no;
                self.officeSupplierArr[desIndex].quantity = "";
            },
            removeOtherSuppDocument: function(object, index) {
                if(self.plusCountOtherSupplier <= 4 ) {
                    self.plusCountOtherSupplier = self.plusCountOtherSupplier + 1;
                    self.otherOfficeSupplierArr.splice(index, 1);
                }
            },
            addNewDocumentOtherSupp: function(object, index) {
                var error = true;
                self.otherOfficeSupplierArr[index].descriptionError = "";
                self.otherOfficeSupplierArr[index].unitMeasureCodeError = "";
                self.otherOfficeSupplierArr[index].itemNoError = "";
                self.otherOfficeSupplierArr[index].quantityError = "";

                if(!self.otherOfficeSupplierArr[index].description) {
                    self.otherOfficeSupplierArr[index].descriptionError = "Enter Description";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.otherOfficeSupplierArr[index].unitMeasureCode) {
                    self.otherOfficeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.otherOfficeSupplierArr[index].itemNo) {
                    self.otherOfficeSupplierArr[index].itemNoError = "Enter Item No";
                    if (error) {
                        error = false;
                    }
                }
                if (!self.otherOfficeSupplierArr[index].quantity) {
                    self.otherOfficeSupplierArr[index].quantityError = "Please enter Quantity";
                    if (error) {
                        error = false;
                    }
                } else if (self.otherOfficeSupplierArr[index].quantity && !self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity)) {
                    self.otherOfficeSupplierArr[index].quantityError = "Please enter numeric value";
                    if (error) {
                        error = false;
                    }
                } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity > 1000) {
                    self.otherOfficeSupplierArr[index].quantityError = "Max Quantity is 1000";
                    if (error) {
                        error = false;
                    }
                } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity <= 0) {
                    self.otherOfficeSupplierArr[index].quantityError = "Please enter valid Quantity";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.plusCountOtherSupplier = self.plusCountOtherSupplier - 1;
                    self.otherOfficeSupplierArr.push(Vue.util.extend({}, self.otherTempOfficeSupplierObject));
                }
            },
            loadVendor: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.get("/vendor/get", config)
                    .then(function (response) {
                        self.vendorIdArr = response.data.content;
                        if(response.data.content && response.data.content.length > 0) {
                            self.vendorId = {text: response.data.content[0].text, value: response.data.content[0].value};
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            changedValueVendor: function(vendor) {
                self.vendorIdError = "";
                self.officeSupplierArr = [];
                self.officeSupplierArr = [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ];
                self.plusCountSupplier = 9;
                self.indexDes = 0;
                // if (vendor.value != undefined) {
                if (vendor.value != null || vendor.value) {
                    self.loadVendorItemData(vendor.value);
                }
            },
            loadVendorItemData: function(vendorId) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        vendor_id: vendorId
                    }
                };
                HTTP.get("/vendor/item/mapper/get", config)
                    .then(function (response) {
                        self.descriptionArr = response.data.content;
                    })
                    .catch(function (err) {
                        console.log(err);
                        // self.catchHandler(err, function () {});
                    });
            },
            changedValue: function () {
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 1
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            if(self.location_arr && self.location_arr.length > 0) {
                                for(var index = 0; index < self.location_arr.length; index++) {
                                    var objLocation = self.location_arr[index];
                                    if(objLocation['name'] == 'BusWest - Woodland, CA' || objLocation['id'] == 37) {
                                        self.location_arr.splice(index, 1);
                                    }
                                }
                                for(var index = 0; index < self.location_arr.length; index++) {
                                    var objLocation = self.location_arr[index];
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - El Centro, CA" || objLocation['id'] == 39) {
                                        self.location_arr[index]['name'] = "El Centro, CA";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - Nogales, AZ" || objLocation['id'] == 33) {
                                        self.location_arr[index]['name'] = "Nogales, AZ";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - San Diego, CA" || objLocation['id'] == 40) {
                                        self.location_arr[index]['name'] = "OTAY";
                                    }
                                }
                                var objOntario = {
                                    "name": "ONTARIO",
                                    "id": 9992,
                                    "position": {
                                        "lat": '',
                                        "lng": ''
                                    },
                                    "is_buswest": false,
                                    "manager_email": "jsanchez@vvgtruck.com",
                                    "manager_name": "Jesse Sanchez"
                                };
                                self.location_arr.push(objOntario);
                            }
                            self.location_arr = self.location_arr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            removeSupplierDocument: function(object, index) {
                if(self.plusCountSupplier <= 9 ) {
                    self.indexDes -= 1;
                    self.plusCountSupplier = self.plusCountSupplier + 1;
                    self.officeSupplierArr.splice(index, 1);
                }
            },
            addNewDocumentSupplier: function(object, index) {
                var error = true;
                self.officeSupplierArr[index].descriptionError = "";
                self.officeSupplierArr[index].unitMeasureCodeError = "";
                self.officeSupplierArr[index].itemNoError = "";
                self.officeSupplierArr[index].quantityError = "";

                if (self.officeSupplierArr[index].description == null || !self.officeSupplierArr[index].description.value) {
                    self.officeSupplierArr[index].descriptionError = "Select Description";
                    if (error) {
                        error = false;
                    }
                }
                if(self.vendorId.text != "Office Solution") {
                    if(!self.officeSupplierArr[index].unitMeasureCode) {
                        self.officeSupplierArr[index].unitMeasureCodeError = "Select Unit Measure Code";
                        if (error) {
                            error = false;
                        }
                    }
                } else {
                    if(!self.officeSupplierArr[index].unitMeasureCode) {
                        self.officeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                        if (error) {
                            error = false;
                        }
                    }
                }
                if(!self.officeSupplierArr[index].itemNo) {
                    self.officeSupplierArr[index].itemNoError = "Enter Item No";
                    if (error) {
                        error = false;
                    }
                }
                if (!self.officeSupplierArr[index].quantity) {
                    self.officeSupplierArr[index].quantityError = "Please enter Quantity";
                    if (error) {
                        error = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && !self.numberFormateValidation(self.officeSupplierArr[index].quantity)) {
                    self.officeSupplierArr[index].quantityError = "Please enter numeric value";
                    if (error) {
                        error = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && self.numberFormateValidation(self.officeSupplierArr[index].quantity) && self.officeSupplierArr[index].quantity > 1000) {
                    self.officeSupplierArr[index].quantityError = "Max Quantity is 1000";
                    if (error) {
                        error = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && self.numberFormateValidation(self.officeSupplierArr[index].quantity) && self.officeSupplierArr[index].quantity <= 0) {
                    self.officeSupplierArr[index].quantityError = "Please enter valid Quantity";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.indexDes += 1;
                    self.plusCountSupplier = self.plusCountSupplier - 1;
                    self.officeSupplierArr.push(Vue.util.extend({}, self.tempOfficeSupplierObject));
                }
            },
            checkForm: function () {
                var checked = true;
                var index = 0;
                self.location_error = "";
                self.departmentIdError = "";
                self.requestorNameError = "";
                self.vendorIdError = "";
                self.descriptionError = "";
                self.unitMeasureCodeError = "";
                self.itemNoError = "";
                self.officeSupplierArr[index].descriptionError = "";
                self.officeSupplierArr[index].unitMeasureCodeError = "";
                self.officeSupplierArr[index].itemNoError = "";
                self.otherOfficeSupplierArr[index].descriptionError = "";
                self.otherOfficeSupplierArr[index].unitMeasureCodeError = "";
                self.otherOfficeSupplierArr[index].itemNoError = "";
                self.otherOfficeSupplierArr[index].quantityError = "";

                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.isHideLocationDropDown) {
                    if (self.location == null || !self.location.id) {
                        self.location_error = "select Location";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.vendorId == null || !self.vendorId.value) {
                    self.vendorIdError = "select vendor";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.requestorName) {
                    self.requestorNameError = "Please enter requestor name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.officeSupplierArr[index].description == null || !self.officeSupplierArr[index].description.value) {
                    self.officeSupplierArr[index].descriptionError = "Select Description";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.vendorId.text != 'Office Solution') {
                    if(!self.officeSupplierArr[index].unitMeasureCode) {
                        self.officeSupplierArr[index].unitMeasureCodeError = "Select Unit Measure Code";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if(!self.officeSupplierArr[index].unitMeasureCode) {
                        self.officeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if(!self.officeSupplierArr[index].itemNo) {
                    self.officeSupplierArr[index].itemNoError = "Enter Item No";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.officeSupplierArr[index].quantity) {
                    self.officeSupplierArr[index].quantityError = "Please enter Quantity";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && !self.numberFormateValidation(self.officeSupplierArr[index].quantity)) {
                    self.officeSupplierArr[index].quantityError = "Please enter numeric value";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && self.numberFormateValidation(self.officeSupplierArr[index].quantity) && self.officeSupplierArr[index].quantity > 1000) {
                    self.officeSupplierArr[index].quantityError = "Max Quantity is 1000";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.officeSupplierArr[index].quantity && self.numberFormateValidation(self.officeSupplierArr[index].quantity) && self.officeSupplierArr[index].quantity <= 0) {
                    self.officeSupplierArr[index].quantityError = "Please enter valid Quantity";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.other) {
                    if(self.otherOfficeSupplierArr[index].description) {
                        if(!self.otherOfficeSupplierArr[index].unitMeasureCode) {
                            self.otherOfficeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if(!self.otherOfficeSupplierArr[index].itemNo) {
                            self.otherOfficeSupplierArr[index].itemNoError = "Enter Item No";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.otherOfficeSupplierArr[index].quantity) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter Quantity";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && !self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity)) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter numeric value";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity > 1000) {
                            self.otherOfficeSupplierArr[index].quantityError = "Max Quantity is 1000";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity <= 0) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter valid Quantity";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                    if(self.otherOfficeSupplierArr[index].unitMeasureCode) {
                        if(!self.otherOfficeSupplierArr[index].description) {
                            self.otherOfficeSupplierArr[index].descriptionError = "Enter Description";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if(!self.otherOfficeSupplierArr[index].itemNo) {
                            self.otherOfficeSupplierArr[index].itemNoError = "Enter Item No";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.otherOfficeSupplierArr[index].quantity) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter Quantity";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && !self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity)) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter numeric value";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity > 1000) {
                            self.otherOfficeSupplierArr[index].quantityError = "Max Quantity is 1000";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity <= 0) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter valid Quantity";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                    if(self.otherOfficeSupplierArr[index].itemNo) {
                        if(!self.otherOfficeSupplierArr[index].description) {
                            self.otherOfficeSupplierArr[index].descriptionError = "Enter Description";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if(!self.otherOfficeSupplierArr[index].unitMeasureCode) {
                            self.otherOfficeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.otherOfficeSupplierArr[index].quantity) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter Quantity";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && !self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity)) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter numeric value";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity > 1000) {
                            self.otherOfficeSupplierArr[index].quantityError = "Max Quantity is 1000";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity <= 0) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter valid Quantity";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                    if (self.otherOfficeSupplierArr[index].quantity) {
                        if(!self.otherOfficeSupplierArr[index].description) {
                            self.otherOfficeSupplierArr[index].descriptionError = "Enter Description";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if(!self.otherOfficeSupplierArr[index].unitMeasureCode) {
                            self.otherOfficeSupplierArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if(!self.otherOfficeSupplierArr[index].itemNo) {
                            self.otherOfficeSupplierArr[index].itemNoError = "Enter Item No";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (self.otherOfficeSupplierArr[index].quantity && !self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity)) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter numeric value";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity > 1000) {
                            self.otherOfficeSupplierArr[index].quantityError = "Max Quantity is 1000";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.otherOfficeSupplierArr[index].quantity && self.numberFormateValidation(self.otherOfficeSupplierArr[index].quantity) && self.otherOfficeSupplierArr[index].quantity <= 0) {
                            self.otherOfficeSupplierArr[index].quantityError = "Please enter valid Quantity";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                return checked;
            },
            addOfficeSupplier(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var strManagerEmail = '';
                        // var strManagerName = '';
                        if(self.departmentId.value == 'Call Center') {
                            strManagerEmail = 'mdozal@vvgtruck.com';
                            // strManagerName = 'Mike Dozal';
                        } else if(self.departmentId.value == 'Central Ops') {
                            strManagerEmail = 'bfinney@vvgtruck.com';
                            // strManagerName = 'Brianna Finney';
                        } else {
                            strManagerEmail = self.managerEmail;
                            // strManagerName = self.managerName;
                        }
                        var fields = {
                            id: self.edit_id,
                            manager_email: strManagerEmail,
                            departmentName: self.departmentId.value,
                            location_id: !self.isHideLocationDropDown ? self.location.id : 0,
                            location: !self.isHideLocationDropDown ? self.location.name : "",
                            requestor_name: self.requestorName,
                            vendor_id: self.vendorId.value,
                            officeSupplierArr: self.officeSupplierArr,
                            otherOfficeSupplierArr: self.otherOfficeSupplierArr,
                            other_option: self.other,
                        };
                        self.showLoader();
                        HTTP.post("/office/supplier/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.edit_id = 0;
                                        self.managerEmail = '';
                                        self.departmentId = '';
                                        self.location = '';
                                        self.vendorId = '';
                                        self.vendorId = {text: 'Office Solution', value: 1};
                                        self.officeSupplierArr = [];
                                        self.officeSupplierArr = [
                                            {
                                                description: "",
                                                descriptionError: "",
                                                unitMeasureCode: "",
                                                unitMeasureCodeError: "",
                                                itemNo: "",
                                                itemNoError: "",
                                                quantity: "",
                                                quantityError: "",
                                            },
                                        ];
                                        self.plusCountSupplier = 9;
                                        self.indexDes = 0;
                                        self.other = 0;
                                        self.showOtherOption = false;
                                        self.otherOfficeSupplierArr = [];
                                        self.otherOfficeSupplierArr = [
                                            {
                                                description: "",
                                                descriptionError: "",
                                                unitMeasureCode: "",
                                                unitMeasureCodeError: "",
                                                itemNo: "",
                                                itemNoError: "",
                                                quantity: "",
                                                quantityError: "",
                                            },
                                        ];
                                        self.plusCountOtherSupplier = 4;
                                        self.isHideLocationDropDown = false;
                                        // self.requestorName = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/OfficeSupplier/AddUpdateOfficeSupplier.vue